__turbopack_context__.v({
  "scroll-area": "RB7K5G_scroll-area",
  "scroll-area__scrollbar": "RB7K5G_scroll-area__scrollbar",
  "scroll-area__scrollbar__thumb": "RB7K5G_scroll-area__scrollbar__thumb",
  "scroll-area__viewport": "RB7K5G_scroll-area__viewport",
  "select-content": "RB7K5G_select-content",
  "select-content__item": "RB7K5G_select-content__item",
  "select-trigger": "RB7K5G_select-trigger",
  "select-trigger__icon": "RB7K5G_select-trigger__icon",
  "select-trigger__value": "RB7K5G_select-trigger__value",
});
